export const getInfiniteScrollTableHeight = (
  enableAutoHeight: boolean,
  height: string | number | undefined,
): string | number | undefined => (enableAutoHeight ? 'auto' : height)

export const isAutoHeightEnabled = (autoHeight: boolean, totalCount: number, maxVisibleRowCount?: number): boolean =>
  autoHeight && totalCount < maxVisibleRowCount!
